import script from "./PlotControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotControls.vue?vue&type=script&setup=true&lang=ts"

import "./PlotControls.vue?vue&type=style&index=0&id=65931dd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.24_vue@3.5.24_typescript@4.5.5__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65931dd9"]])

export default __exports__